/* eslint-disable */
import React from 'react';
import {
  SYS_BORDER_RADIUS_MD,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_FIXED_400,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import GpsButton from '../GpsButton/GpsButton';
import SearchForm from './SearchForm';
import searchGroupContext from '../../../contexts/search-group-context';
import config from '../../../config/config.json';
import type { UnifiedTheme } from '../../../FeatureApp';
import FilterButton from '../FiltersButton/FilterButton';
import searchStateContext from '../../../contexts/map-context';

export default function SearchGroup() {
  const { isAutocompletionOpen, results } = searchStateContext.useMapState();
  return (
    <SearchFormContainer data-test-id="search-group">
      <searchGroupContext.Provider>
        <Div>
          <SearchForm />
          {!isAutocompletionOpen && results && (
            <FilterButton data-test-id="component-filter-button" />
          )}
        </Div>
        <GpsButton />
      </searchGroupContext.Provider>
      <div id={`${config.searchInputId}-options`} style={{ display: 'none' }} aria-hidden="true" />
      <div id="search-input" style={{ display: 'none' }} aria-hidden="true" />
    </SearchFormContainer>
  );
}
const isLegacy = process.env.IS_LEGACY;

const SearchFormContainer = styled.div`
  max-height: 100%;
  padding: ${SYS_SPACE_FIXED_350} ${SYS_SPACE_FIXED_350} ${SYS_SPACE_FIXED_400};
  background-color: ${(props: UnifiedTheme) =>
    props.theme.sys.color.canvas[200] || props.theme.sys.color.canvas.default};

  .search-dealer-field:focus {
    outline: none;
  }

  .search-dealer-field.focus-visible {
    outline: 2px solid dodgerblue;
  }

  border-top-right-radius: ${isLegacy ? 'none' : SYS_BORDER_RADIUS_MD};
  border-top-left-radius: ${isLegacy ? 'none' : SYS_BORDER_RADIUS_MD};
`;

const Div = styled.div`
  display: inline-flex;
  gap: ${SYS_SPACE_FIXED_150};
  width: 100%;
`;
